import {
  GET_CHANNEL,
  GET_CHANNELS_ALL,
  GET_FEEDBACK_FORM,
  GET_TWITTER_CODE,
  GET_WIDGET,
  SINGLE_FEEDBACK_FORM,
  UPDATE_WIDGET_LOGO,
} from 'actions/types'

export default function (state = {}, action) {
  switch (action.type) {
    case GET_FEEDBACK_FORM:
      return {
        ...state,
        feedbackFormList: action.payload,
      }
    case SINGLE_FEEDBACK_FORM:
      return {
        ...state,
        feedbackForm: action.payload,
      }

    case GET_WIDGET:
      return {
        ...state,
        widget: action.payload,
      }

    case UPDATE_WIDGET_LOGO:
      return {
        ...state,
        widgetLogoData: action.payload,
      }

    case GET_TWITTER_CODE:
      return {
        ...state,
        twitterCodeData: action.payload,
      }

    case GET_CHANNELS_ALL:
      return {
        ...state,
        getAllChannelList: action.payload,
      }

    case GET_CHANNEL:
      return {
        ...state,
        getChannelData: action.payload,
      }

    default:
      return state
  }
}
